var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-bi",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-90.5 0H592v512H-90.5z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(84.9) scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#18b637",
    d: "m-178 0 428.8 256L-178 512zm857.6 0L250.8 256l428.8 256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf0921",
    d: "m-178 0 428.8 256L679.6 0zm0 512 428.8-256 428.8 256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M679.6 0h-79.9L-178 464.3V512h79.9L679.6 47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M398.9 256a148 148 0 1 1-296.1 0 148 148 0 0 1 296 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-178 0v47.7L599.7 512h79.9v-47.7L-98.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf0921",
    stroke: "#18b637",
    strokeWidth: 3.9,
    d: "m280 200.2-19.3.3-10 16.4-9.9-16.4-19.2-.4 9.3-16.9-9.2-16.8 19.2-.4 10-16.4 9.9 16.5 19.2.4-9.3 16.8zm-64.6 111.6-19.2.3-10 16.4-9.9-16.4-19.2-.4 9.3-16.9-9.2-16.8 19.2-.4 10-16.4 9.9 16.5 19.2.4-9.3 16.8zm130.6 0-19.2.3-10 16.4-10-16.4-19.1-.4 9.3-16.9-9.3-16.8 19.2-.4 10-16.4 10 16.5 19.2.4-9.4 16.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/bi.2bea8a3a.svg";
export { ForwardRef as ReactComponent };